import axios from 'axios';

const baseURL = process.env.REACT_APP_API_URL;

export const axiosJSON = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json'
  }
});

export const axiosFormData = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'multipart/form-data'
  }
});



// WEBPACK FOOTER //
// ./src/axiosInstances.js